// Find multiple options by their values (for multi-selects)
export function findOptionsByValues(options, values) {
  if (!Array.isArray(options) || !values) return [];
  const valueArray = Array.isArray(values)
    ? values
    : values.split(",").map((v) => v.trim());
  return valueArray
    .map((val) => options.find((opt) => String(opt.value) === String(val)))
    .filter(Boolean);
}

// Serialize multi-select value to comma-separated string of IDs
function serializeMultiSelect(value) {
  if (!value || (Array.isArray(value) && value.length === 0)) return "";
  if (Array.isArray(value)) {
    return value.map((v) => v?.value ?? v).join(",");
  }
  return value?.value ?? value ?? "";
}

/**
 * Build filter object from URL search params
 * @param {Object} params - Parsed URL search params
 * @param {Object} options - Available dropdown options
 * @returns {Object} Filter data object for the form
 */
export function buildFilterFromParams(params, options) {
  const { userOptions, jobStatusOptions, mediaOptions, territoryOptions } =
    options;

  const filterData = {};

  // Text fields
  if (params.jobId) filterData.jobId = params.jobId;
  if (params.catalogId) filterData.catalogId = params.catalogId;
  if (params.catalogName) filterData.catalogName = params.catalogName;

  // Radio field
  if (params.tprDisplay) filterData.tprDisplay = params.tprDisplay;

  // Checkbox group (array of strings)
  if (params.licenseeType) {
    filterData.licenseeType = params.licenseeType
      .split(",")
      .map((v) => v.trim());
  }

  // Multi-select fields (only if options are loaded)
  if (params.users && userOptions.length > 0) {
    filterData.users = findOptionsByValues(userOptions, params.users);
  }
  if (params.status && jobStatusOptions.length > 0) {
    filterData.status = findOptionsByValues(jobStatusOptions, params.status);
  }
  if (params.media && mediaOptions.length > 0) {
    filterData.media = findOptionsByValues(mediaOptions, params.media);
  }
  if (params.territory && territoryOptions.length > 0) {
    filterData.territory = findOptionsByValues(
      territoryOptions,
      params.territory,
    );
  }

  if (params.pageSize) {
    filterData.pageSize = Number(params.pageSize);
  }

  return filterData;
}

// Cleans the job filter object by removing empty or null values
export function cleanJobFilter(filter, licJobRange, licJobSort) {
  const filtered = {};

  // Text fields
  if (filter.jobId) filtered.jobId = filter.jobId;
  if (filter.catalogId) filtered.catalogId = filter.catalogId;
  if (filter.catalogName) filtered.catalogName = filter.catalogName;

  // Multi-select fields - serialize to comma-separated IDs
  const usersVal = serializeMultiSelect(filter.users);
  if (usersVal) filtered.users = usersVal;

  const statusVal = serializeMultiSelect(filter.status);
  if (statusVal) filtered.status = statusVal;

  const mediaVal = serializeMultiSelect(filter.media);
  if (mediaVal) filtered.media = mediaVal;

  const territoryVal = serializeMultiSelect(filter.territory);
  if (territoryVal) filtered.territory = territoryVal;

  // Checkbox group (array of strings)
  if (filter.licenseeType && filter.licenseeType.length > 0) {
    filtered.licenseeType = filter.licenseeType.join(",");
  }

  // Radio field
  if (filter.tprDisplay) filtered.tprDisplay = filter.tprDisplay;

  // Pagination
  filtered.licJobRange = licJobRange;
  filtered.licJobSort = licJobSort;
  if (filter.pageSize) filtered.pageSize = filter.pageSize;

  return filtered;
}
